<template>
    <div>
        <ui-crud title="Estimates" subtitle="All Estimates for this package." ref="crud"
                 :collapsable="true"
                 :fetch="fetch" :group-by="groupByStatus" :pipe-with="pipeItems" :create="createNew">

            <template v-slot:new-button>
                <div class="flex items-center">
                    <h1 v-text="'Estimates'" class="text-lg font-medium text-gray-900"></h1>
                    <div v-if="(estimateClipboard.length < 2) && isNull(estimateClipboard[0])"
                         class="ml-auto hidden sm:inline-flex">
                        <ui-button-new small class="ml-auto hidden sm:inline-flex" icon="fas fa-plus"
                                       @click.prevent="createNew()">New
                        </ui-button-new>
                    </div>
                    <div v-else class="ml-auto hidden sm:inline-flex">
                        <ui-dropdown placement="bottom-end" class="ml-auto" menu-class="p-3 w-64 z-[60]" :key="userKey">
                            <template #default="{ toggle }">
                                <ui-button-new @click="toggle" small class="ml-auto hidden sm:inline-flex">
                                    <i class="text-gray-400 flex-shrink-0 mr-2 fa fa-chevron-down"></i>
                                    New
                                </ui-button-new>
                            </template>
                            <template #menu="{ close }">
                                <ui-dropdown-item icon="fas fa-print" @click="createNew();close();">Create new Estimate
                                </ui-dropdown-item>
                                <ui-dropdown-divider></ui-dropdown-divider>
                                <ui-dropdown-item icon="fas fa-paste"
                                                  v-if="(estimateClipboard[0])"
                                                  @click="pasteEstimate(estimateClipboard[0]);close();">
                                    Paste as New Estimate
                                </ui-dropdown-item>
                                <ui-dropdown-divider v-if="estimateClipboard[0]"></ui-dropdown-divider>
                                <ui-dropdown-item ref="paste1item"
                                                  v-if="estimateClipboard.length > 1"
                                                  @mouseleave="closePasteSubMenu(1)"
                                                  @mouseenter="openPasteSubMenu(1)"
                                                  icon="fas fa-clipboard"
                                                  :submenu="true"
                                >Library
                                    <div class="fixed" style="width:auto;height:auto;overflow: visible;"
                                         :ref="'paste1relative'">
                                        <vue-context :ref="'paste1menu'"
                                                     class="inline pb-0 focus:outline-none focus:ring-0 z-50"
                                                     :close-on-click="false" :close-on-scroll="false">
                                            <div :id="'paste1menu'"
                                                 class="p-3 w-72 z-50 bg-white rounded-lg border border-gray-300 shadow-lg">
                                                <ui-dropdown-item icon="fas fa-paste"
                                                                  button-class="truncate"
                                                                  class="w-full truncate flex"
                                                                  v-for="(tem,i) in estimateClipboard"
                                                                  :key="'paste1-'+i"
                                                                  v-if="i > 0"
                                                                  @click="pasteEstimate(tem.data);close();">
                                                    <div class="text-xs text-blue-500 truncate">{{ tem.name }}</div>
                                                </ui-dropdown-item>
                                            </div>
                                        </vue-context>
                                    </div>
                                </ui-dropdown-item>
                            </template>
                        </ui-dropdown>
                    </div>
                </div>
                <p v-text="'All Estimates for this package.'" class="mt-1 text-sm text-gray-600"></p>
                <ui-button-new class="sm:hidden mt-4" icon="fas fa-plus"
                               @click.prevent="createNew()">New
                </ui-button-new>
            </template>
            <!-- Filters. -->
            <template #filters>
                <div class="relative">
                    <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                    <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </template>

            <!-- List item. -->
            <template #list-item="{ item, select, active }">
                <div
                    class="px-6 pb-5 cursor-pointer border-t border-gray-200"
                    :class="{
            'bg-blue-50 hover:bg-gray-50 ': active,
            'hover:bg-gray-50 ': ! active,
            'pt-5': true,
        }"
                    tabindex="0"
                    @click="select()"
                >
                    <div class="flex w-full">
                        <div class="flex-shrink w-full max-w-[270px] flex flex-col">
                            <div class="flex">
                                <h2 v-text="item.title" class="flex-1 text-sm font-medium text-gray-900 truncate"></h2>
                            </div>
                            <div class="flex">
                                <p v-text="item.summarySubject?item.summarySubject:'-- No subject --'"
                                   class="flex-1 mt-1 text-sm text-gray-500"></p>
                            </div>
                        </div>
                        <div class="overflow-visible">
                        <span class="text-right">
                            <p v-text="'#'+item.reference"
                               class="ml-2 text-xs text-gray-500 truncate"></p>
                            <p v-text="toCurrency(item.total)"
                               class="ml-2 text-sm font-medium text-gray-900 truncate"></p>
                            <p class="ml-2 text-xs text-gray-900 truncate">
                                <i v-if="item.usedInContract" @mouseenter="(e) => openUsedMenu(e,item)"
                                   @mouseleave="closeAllMenus"
                                   class="fa fa-check text-green-400 ml-0.5" style="font-size: 12px"></i>
                                <i v-if="item.revoked" @mouseenter="(e) => openRevokedMenu(e,item)"
                                   @mouseleave="closeAllMenus"
                                   class="fa fa-times-circle text-gray-400 ml-0.5" style="font-size: 12px"></i>
                                <i v-if="item.invited" @mouseenter="(e) => openEmailedMenu(e,item)"
                                   @mouseleave="closeAllMenus"
                                   class="far fa-envelope text-gray-400 ml-0.5" style="font-size: 12px"></i>
                                <i v-if="item.viewed" @mouseenter="(e) => openViewedMenu(e,item)"
                                   @mouseleave="closeAllMenus"
                                   class="fa fa-eye text-gray-400 ml-0.5" style="font-size: 12px"></i>
                                <!--
                               <i v-if="item.downloaded" @mouseenter="(e) => openDownloadedMenu(e,item)"
                                  @mouseleave="closeDownloadedMenu"
                                  class="far fa-cloud-download text-gray-400 ml-0.5" style="font-size: 12px"></i>
                              -->
                            </p>
                       </span>
                        </div>
                    </div>
                </div>
            </template>

            <!-- Create form. -->
            <template #create="{ addItem }">
                <div class="flex m-8" v-if="!loaded">
                    Loading Estimates....
                </div>
                <div class="flex m-8" v-else>
                    Please select an estimate to edit or click new to create a new estimate.
                </div>
            </template>

            <template #show="{ selectedItem, setEditMode }">
                <estimate :id="selectedItem.id" :user="user" :selectedItem="selectedItem" @deleted="deleted"
                          ref="estimate" @ready="ready"
                          @estimateSelect="estimateSelect"></estimate>
            </template>
        </ui-crud>
        <vue-context ref="revokedMenu" class="fixed p-0 focus:outline-none focus:ring-0 z-30 ml-2.5 -mt-1.5"
                     :close-on-click="false"
                     :close-on-scroll="false">
            <div ref="revokedMenuContent"
                 class="p-3 w-auto z-30 bg-white rounded-lg border border-gray-300 shadow-lg menu">
                <div v-if="mousedOver" :key="mousedOver.id">
                    <div class="text-sm" v-for="sent in mousedOver.sendLog.filter((i) => i.status === 'Revoked')"><span
                        class="text-blue-700">{{ sent.handle }}</span> last sent at <span
                        class="text-gray-600 font-semibold">{{ sent.requested.at }}</span><span
                        class="text-red-600 ml-2"> (revoked)</span>
                    </div>
                </div>
                <div class="p-3" v-else>
                    Loading...
                </div>
            </div>
        </vue-context>
        <vue-context ref="emailedMenu" class="fixed p-0 focus:outline-none focus:ring-0 z-30 ml-2.5 -mt-1.5"
                     :close-on-click="false"
                     :close-on-scroll="false">
            <div ref="emailedMenuContent"
                 class="p-3 w-auto z-30 bg-white rounded-lg border border-gray-300 shadow-lg menu">
                <div v-if="mousedOver" :key="mousedOver.id">
                    <div class="text-sm" v-for="sent in mousedOver.sendLog">
                        <span class="text-blue-700">{{ sent.handle }}</span> last sent at
                        <span class="text-gray-600 font-semibold">{{ sent.requested.at }}</span>
                    </div>
                </div>
                <div class="p-3" v-else>
                    Loading...
                </div>
            </div>
        </vue-context>
        <vue-context ref="viewedMenu" class="fixed p-0 focus:outline-none focus:ring-0 z-30 ml-2.5 -mt-1.5"
                     :close-on-click="false"
                     :close-on-scroll="false">
            <div ref="viewedMenuContent"
                 class="p-3 w-auto z-30 bg-white rounded-lg border border-gray-300 shadow-lg menu">
                <div v-if="mousedOver" :key="mousedOver.id">
                    <div class="text-sm" v-for="sent in mousedOver.sendLog" v-if="sent.viewedAt">
                        <span class="text-blue-700">{{ sent.handle }}</span> viewed at
                        <span class="text-gray-600 font-semibold">{{ sent.viewedAt }}</span>
                    </div>
                </div>
                <div class="p-3" v-else>
                    Loading...
                </div>
            </div>
        </vue-context>
        <vue-context ref="usedMenu" class="fixed p-0 focus:outline-none focus:ring-0 z-30 ml-2.5 -mt-1.5"
                     :close-on-click="false"
                     :close-on-scroll="false">
            <div ref="usedMenuContent"
                 class="p-3 w-auto z-30 bg-white rounded-lg border border-gray-300 shadow-lg menu">
                This is estimate has been used in an accepted contract
            </div>
        </vue-context>
        <vue-context ref="downloadedMenu" class="fixed p-0 focus:outline-none focus:ring-0 z-30 ml-2.5 -mt-1.5"
                     :close-on-click="false"
                     :close-on-scroll="false">
            <div ref="downloadedMenuContent"
                 class="p-3 w-auto z-30 bg-white rounded-lg border border-gray-300 shadow-lg menu">
                <div v-if="mousedOver" :key="mousedOver.id">
                    <div class="text-sm" v-for="sent in mousedOver.sendLog">
                        <span class="text-blue-700">{{ sent.handle }}</span> last sent at
                        <span class="text-gray-600 font-medium">{{ sent.requested.at }}</span>
                    </div>
                </div>
                <div class="p-3" v-else>
                    Loading...
                </div>
            </div>
        </vue-context>
    </div>
</template>

<script>
import UiInput from "../../ui/UiInput.vue";
import UiCrud from "../../ui/UiCrud.vue";
import UiCrudCard from "../../ui/UiCrudCard.vue";
import {toCurrency, uuid} from "../../../utils";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import {Estimate} from "@models";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import remoteStorage from "../../../utils/remoteStorage";
import User from "../../../services/User";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import {isNull} from "lodash";
import estimate from "./Estimate.vue";

export default {
    components: {UiDropdownDivider, UiButtonNew, UiDropdownItem, UiDropdown, UiCrudCard, UiCrud, UiInput},
    props: {
        packageReference: null,
        admin: Boolean,
        showWhenLoaded: false,
    },
    data() {
        let estimateClipboardData = [];
        try {
            estimateClipboardData = remoteStorage.getItem('estimate-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-clipboard')) : [];
        } catch (e) {
            //continue on JSON ERROR
        }
        return {
            search: '',
            estimates: [],
            currentItem: false,
            loaded: false,
            mousedOver: false,
            userKey: 1,
            estimateClipboard: estimateClipboardData,
            user: {},
            goEditMode: false,
        }
    },
    watch: {
        userClipboardToBeWatched: {
            handler(newValue, oldValue) {
                this.estimateClipboard = remoteStorage.getItem('estimate-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-clipboard')) : [];
                this.userKey++;
            },
        },
    },
    computed: {
        userClipboardToBeWatched() {
            return this.user.remoteStorage ? this.user.remoteStorage['estimate-clipboard']
                : '';
        },
    },
    methods: {
        isNull,
        openPasteSubMenu(num) {
            const p = "paste" + num + "menu"
            if (this.$refs[p][0]) {
                this.$refs[p][0].open(new window.MouseEvent('mouse'))
            } else {
                this.$refs[p].open(new window.MouseEvent('mouse'))
            }
            this.positionPasteMenu(num)
        },
        closePasteSubMenu(num) {
            const p = "paste" + num + "menu"
            if (this.$refs[p][0]) {
                this.$refs[p][0].close()
            } else {
                this.$refs[p].close()
            }
        },
        positionPasteMenu(num) {
            this.$nextTick(() => {
                if (this.$refs["paste" + num + "relative"][0]) {
                    this.$refs["paste" + num + "relative"][0].setAttribute('style', '')
                } else {
                    this.$refs["paste" + num + "relative"].setAttribute('style', '')
                }
                this.$nextTick(() => {
                    let opener, box
                    if (this.$refs["paste" + num + "item"][0]) {
                        opener = this.$refs["paste" + num + "item"][0].$refs.submenu.getBoundingClientRect()
                    } else {
                        opener = this.$refs["paste" + num + "item"].$refs.submenu.getBoundingClientRect()
                    }
                    if (this.$refs["paste" + num + "menu"][0]) {
                        box = this.$refs["paste" + num + "menu"][0].$el.getBoundingClientRect()
                    } else {
                        box = this.$refs["paste" + num + "menu"].$el.getBoundingClientRect()
                    }
                    let left = Math.min(opener.x - box.x - 10, window.innerWidth - (box.right) - 17);
                    let top = Math.min(opener.y - box.y - 10, window.innerHeight - (box.bottom) - 28);
                    if (this.$refs["paste" + num + "relative"][0]) {
                        this.$refs["paste" + num + "relative"][0].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                    } else {
                        this.$refs["paste" + num + "relative"].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                    }
                })
            })
        },
        async pasteEstimate(item) {
            remoteStorage.setItem('estimate-clipboard-view', 'estimate');
            this.loaded = false
            const id = uuid();
            await Estimate.create(this.packageReference, id);
            let e = await Estimate.find(id);
            Object.assign(e, item)
            e.id = id;
            await e.save();
            if (!this.estimates.length) {
                this.$refs.crud.fetchItems().then(() => {
                    this.goEditMode = true
                    this.$refs.crud.fetch(id)
                })
            } else {
                this.goEditMode = true
                this.$refs.crud.fetch(id)
            }
        },
        openEmailedMenu(e, item) {
            this.$refs.emailedMenu.open(e)
            if (!this.mousedOver || (this.mousedOver.id !== item.id)) {
                this.mousedOver = false
                Estimate.find(item.id).then((result) => this.mousedOver = result)
            }
        },
        openRevokedMenu(e, item) {
            this.$refs.revokedMenu.open(e)
            if (!this.mousedOver || (this.mousedOver.id !== item.id)) {
                this.mousedOver = false
                Estimate.find(item.id).then((result) => this.mousedOver = result)
            }
        },
        openViewedMenu(e, item) {
            this.$refs.viewedMenu.open(e)
            if (!this.mousedOver || (this.mousedOver.id !== item.id)) {
                this.mousedOver = false
                Estimate.find(item.id).then((result) => this.mousedOver = result)
            }
        },
        openUsedMenu(e, item) {
            this.$refs.usedMenu.open(e)
        },
        openDownloadedMenu(e, item) {
            this.$refs.downloadedMenu.open(e)
            if (!this.mousedOver || (this.mousedOver.id !== item.id)) {
                this.mousedOver = false
                Estimate.find(item.id).then((result) => this.mousedOver = result)
            }
        },
        closeAllMenus(e) {
            this.$refs.emailedMenu.close()
            this.$refs.revokedMenu.close()
            this.$refs.viewedMenu.close()
            this.$refs.downloadedMenu.close()
            this.$refs.usedMenu.close()
        },
        closeEmailedMenu(e) {
            this.$refs.emailedMenu.close()
        },
        closeRevokedMenu(e) {
            this.$refs.revokedMenu.close()
        },
        closeViewedMenu(e) {
            this.$refs.viewedMenu.close()
        },
        closeUsedMenu(e) {
            this.$refs.usedMenu.close()
        },
        closeDownloadedMenu(e) {
            this.$refs.downloadedMenu.close()
        },
        toCurrency,
        async fetch(itemId) {
            this.loaded = false
            this.estimates = await Estimate.list(this.packageReference)
            let item = false;
            if (itemId) {
                item = await this.estimates.find((i) => i.id === itemId)
            } else if (this.estimates.length) {
                item = this.estimates[0];
            }
            if (item) {
                this.$refs.crud.selectItem(item)
            }
            this.loaded = true
            return this.estimates;
        },
        ready(e) {
            if (this.goEditMode) {
                this.$refs.estimate.toggleEditMode(false)
            } else {
                let lastUpdate = this.$refs.estimate.estimate.lastUpdatedByReference ? this.$refs.estimate.estimate.lastUpdatedByReference : this.$refs.estimate.estimate.createdByReference
                let lastEditing = this.$refs.estimate.estimate.editing ? this.$refs.estimate.estimate.editingByReference : false
                if ((lastUpdate === User.user.id) && (!lastEditing || (lastEditing === User.user.id))) {
                    this.$refs.estimate.toggleEditMode(false)
                }
            }
            this.goEditMode = false;
        },
        async createNew() {
            this.loaded = false
            const id = uuid();
            const result = await Estimate.create(this.packageReference, id);
            if (!this.estimates.length) {
                this.$refs.crud.fetchItems().then(() => {
                    this.goEditMode = true;
                    this.$refs.crud.fetch(id, true)
                })
            } else {
                this.goEditMode = true;
                this.$refs.crud.fetch(id, true)
            }
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-\/]+/);
            if (query.length) {
                return this.estimates.filter((estimate) => {
                    return query.every((token) => {
                        return estimate.tokens.includes(token);
                    })
                });
            }
            return this.estimates
        },
        groupByStatus(estimate) {
            return estimate.status
        },
        deleted(q) {
            this.$refs.crud.fetch()
        },
        async estimateSelect(id, editMode = false) {
            this.loaded = false
            if (!this.estimates.length) {
                this.$refs.crud.fetchItems().then(() => {
                    this.goEditMode = editMode
                    this.$refs.crud.fetch(id)
                })
            } else {
                this.goEditMode = editMode
                await this.$refs.crud.fetch(id)
            }
        },
        updateFromListener(data) {
            if (data.operation === 'updateAggregate') {
                if (data.aggregate.type === 'Estimate') {
                    let target = this.estimates.find((i) => i.id === data.aggregate.id)
                    if (target) {
                        Object.assign(target, data.aggregate.data)
                    }
                }
            }
        }
    },
    async mounted() {
        await User.register()
        this.user = User.user
        this.$refs.crud.fetch(this.showWhenLoaded).then(() => {
            User.registerAggregates(this.estimates.map((estimate) => {
                return {"type": 'Estimate', 'id': estimate.id};
            }), this.updateFromListener)
        })
    }
}
</script>
